import { render, staticRenderFns } from "./ModalItem.vue?vue&type=template&id=87e0c334&scoped=true&"
import script from "./ModalItem.vue?vue&type=script&lang=ts&"
export * from "./ModalItem.vue?vue&type=script&lang=ts&"
import style0 from "./ModalItem.vue?vue&type=style&index=0&id=87e0c334&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87e0c334",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol})
